import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import HtmlHead from 'client/components/htmlHead';
import Translate from 'client/components/translate';
import Card from 'client/components/card/card';
import InteractiveList from 'client/components/list/interactiveList/interactiveList';
import { ProfessionShape } from 'client/constants/tax/shapes';
import { defaultIllustration } from 'client/components/tax/illustration';

const mapStateToProps = state => ({
  professions: state.professions.content,
});

const propTypes = {
  professions: PropTypes.arrayOf(ProfessionShape),
  router: PropTypes.object.isRequired,
};

const defaultProps = {
  professions: [],
};

const JobsPage = ({ professions, router }) => {
  const allItems = professions.map(profession => ({
    id: profession.id,
    title: profession.displayName,
    subtitle: profession.subtitle,
    displayName: profession.displayName,
    illustration: profession.illustration.images.reduce(
      (result, image) => (image.contentType === 'image/svg+xml' ? image.url : result),
      defaultIllustration,
    ),
    url: `deductions/${profession.seoSlug}`,
  }));

  return (
    <div className="center-col pad-bottom-2">
      <HtmlHead title="Stride Health - Tax Deduction Guide - Select Job">
        <meta name="keywords" content={professions.map(p => p.displayName).join(', ')} />
      </HtmlHead>
      <Card className="flush-top flush-small">
        <div>
          <h3 className="text-center margin">
            <Translate path="taxes.deductionGuide.professions.singleJobTitle" />
          </h3>
          <p className="text-center margin-bottom-2">
            <Translate path="taxes.deductionGuide.professions.singleJobSubtitle" />
          </p>
          <InteractiveList className="flush" allItems={allItems} router={router} />
          <div className="text-center" style={{ padding: '3rem 1rem 1rem' }}>
            <Link to={'deductions/select-job'}>
              <Translate path="taxes.deductionGuide.professions.multipleJobsRedirect" />
            </Link>
          </div>
        </div>
      </Card>
    </div>
  );
};

JobsPage.propTypes = propTypes;
JobsPage.defaultProps = defaultProps;

export default connect(mapStateToProps)(JobsPage);
